import React, { Fragment, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import TableMetaContext from 'src/utils/context/TableMetaContext';
import ColumnFilters from 'src/components/DataGrid/ColumnFilters';
import { useTranslation } from 'react-i18next';
import s from './DataGridBaseHeader.styles';

const DataGridBaseHeader = ({ children, filtersAlwaysVisible, ...rest }) => {
  const { t } = useTranslation();
  const {
    refetch,
    name,
    columns,
    filters,
    filtersVisible,
    setFilters,
    setFiltersVisible,
    withDeleted,
    setWithDeleted,
    hideDeletedButton = false,
    hideColumnFilter,
  } = useContext(TableMetaContext);

  let filtersIndex = 1;
  if (name === 'UsersGrid') {
    filtersIndex = 3;
  }

  return (
    <div {...rest}>
      {React.Children.map(children, (child, index) => {
        if (index === filtersIndex) {
          return (
            <Fragment>
              {child}
              {!hideColumnFilter &&
                <s.FilterToggleBtn
                  onClick={() => setFiltersVisible(!filtersVisible)}
                >
                  {filtersVisible ? t('HIDE_FILTERS') : t('SHOW_FILTERS')}
                </s.FilterToggleBtn>
              }
            </Fragment>
          );
        }

        return child;
      })}
      {!hideColumnFilter && (filtersAlwaysVisible || filtersVisible) && (
        <ColumnFilters
          columns={columns}
          filters={filters}
          hideDeletedButton={hideDeletedButton}
          refetch={refetch}
          setFilters={setFilters}
          setWithDeleted={setWithDeleted}
          withDeleted={withDeleted}
        />
      )}
    </div>
  );
};

DataGridBaseHeader.propTypes = {
  children: PropTypes.any,
  filtersAlwaysVisible: PropTypes.bool,
};

DataGridBaseHeader.defaultProps = {
  filtersAlwaysVisible: false,
};

export default React.memo(DataGridBaseHeader);
